module.exports = __webpack_public_path__ + "img/icon_yongdian.a67d2687.svg";